import React from 'react'
import { CheckboxField } from '@livechat/design-system'

const MultiChoiceAnswer = ({ field, response, setResponse, index }) => {
  return field.answers?.map((answer, i) => {
    const resp = response[index] || []
    return (
      <CheckboxField
        key={answer}
        checked={resp.includes(i)}
        onChange={() => {
          if (resp.includes(i)) {
            setResponse({
              ...response,
              [index]: [...resp].filter((answer_index) => answer_index !== i),
            })
          } else {
            setResponse({
              ...response,
              [index]: [...resp, i],
            })
          }
        }}
      >
        {answer}
      </CheckboxField>
    )
  })
}

export default MultiChoiceAnswer
